import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-water-flash-line text-foreground-950 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90">
              {siteInfo.tagline}。我们把分散的娱乐话题整理成分类合集，让分区浏览真正能派上用场。
            </p>
            <p className="mt-4 text-xs text-background-300/70 tracking-wider">
              自 {siteInfo.since} 年起整理话题合集
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">
              分类合集
            </h3>
            <ul className="space-y-3">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">
              站内导航
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/yulequan"
                  className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  热门话题
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  联系与投稿
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h3>
            <ul className="space-y-3 text-sm text-background-200/85">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="hover:text-accent-400 transition-colors break-all cursor-pointer"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5"></i>
                <span>{siteInfo.workingHours}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5"></i>
                <span>不发布未核实信息，不传播来源不明素材</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © {new Date().getFullYear()} {siteInfo.name}. 内容仅供话题讨论与信息整理。
          </p>
          <p className="text-xs text-background-300/70">
            站内内容不针对任何真实个人进行定性描述
          </p>
        </div>
      </div>
    </footer>
  );
}